import React, { Fragment, useEffect } from 'react'
import { connect } from 'react-redux'

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { setToken } from './features/auth/authSlice'
import Authentication from './components/Pages/Authentication'
import Layout from './components/Pages/Layout'
import Load from './components/Pages/Load'
import AppInfo from './components/Pages/AppInfo'
import jwt_decode from 'jwt-decode'
import GetStarted from './components/Pages/GetStarted'
import Summary from './components/Pages/Summary'
import Updates from './components/Pages/Updates'
import Timeline from './components/Pages/Timeline'
import DocumentsPage from './components/Pages/DocumentsPage'
import PollPage from './components/Pages/PollPage'
import FormsPage from './components/Pages/FormsPage'
import WebsitePage from './components/Pages/WebsitePage'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Allusers from './components/Pages/Allusers'
import Chatscreen from './components/Pages/Chatscreen'
import Allusersunitplan from './components/Pages/Allusersunitplan'
import SingleUserunitplan from './components/Pages/singleuserunitplan'
import PaymentDetails from './components/Pages/PaymentDetails'

const App = ({
  authToken,
  userAccess,
  setToken
}) => {
   const validateToken = () => {
    let token = authToken;

    if (!token) {
      token = localStorage.getItem('token');
      if (!token) return false;

      try {
        const tokenData = jwt_decode(token);
        if (!tokenData) return false;

        // optionally, you can validate expiration here
        // if (tokenData.exp && new Date(tokenData.exp * 1000) < new Date()) return false;

        // Save token to Redux
        setToken({ authToken: token });
        return true;
      } catch (error) {
        console.error('Invalid token:', error);
        localStorage.removeItem('token');
        return false;
      }
    }

    return true;
  };
      // if (tokenData && new Date(tokenData.exp * 1000) > new Date()) {

      //   if (tokenData?.userInfo?.hasOwnProperty('ID') && tokenData?.userInfo?.hasOwnProperty('RoleID')) {
      //     setToken({ authToken: token })
      //     return true
      //   } else {
      //     // localStorage.clear()
      //     return false
      //   }
      // } else {
      //   // localStorage.clear()
      //   return false
      // }
  const userLoggedIn = validateToken()
  // Read permissions from the token itself: on a hard reload the store still
  // holds the default member access during this first render.
  const getAccess = () => {
    try {
      const token = authToken || localStorage.getItem('token')
      const access = token ? jwt_decode(token)?.userAccess : null
      return Array.isArray(access) ? access : (userAccess || [])
    } catch (e) {
      return userAccess || []
    }
  }
  const isAdmin = userLoggedIn && getAccess().includes('ListUser')
  // console.log(userLoggedIn)
  console.log(userLoggedIn)
  
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
        {!userLoggedIn &&
          <Fragment>
            <Route path="*" element={<Auth />} />
            <Route path="getStarted" element={<GetStartedView />} />
            {/* <Route path="getStartedLogin" element={<GetStartedLoginView />} /> */}
          </Fragment>
         } 
        {userLoggedIn &&
          <Fragment>
            <Route path="/" element={<UpdatesView />} />
            <Route path="updates" element={<UpdatesView />} />
            <Route path="timeline" element={<TimelineView />} />
            <Route path="documents" element={<DocumentView />} />
            <Route path="poll" element={<PollPageView />} />
            <Route path='msg' element={<AboutChat/>} />
            <Route path="forms" element={<FormsView />} />
            <Route path="website" element={<WebsiteView />} />
            <Route path="getStarted" element={<GetStartedView />} />
            <Route path="appinfo" element={<AboutApp />} />
            <Route path="allusers" element={<Allusersview/>} />
            <Route
              path="alluserunitplan"
              element={isAdmin ? <Allusersunit /> : <Navigate to="/singleuserunitplan" replace />}
            />
            <Route path="singleuserunitplan" element={< Singleusers />} />
            <Route path="payment-details" element={<PaymentDetailsView />} />
            <Route path="load" element={<SelectWebsiteList />} />
            <Route path="summary" element={<SummaryView />} />
            <Route path="*" element={<Auth />} />
          </Fragment>
       }
       
        </Routes>
        <ToastContainer />
      </BrowserRouter>
    </div>
  );
}

function Auth() {
  return (
    <div className="App">
      <Authentication></Authentication>
    </div>
  )
}

function SelectWebsiteList() {
  return (
    <div className="App">
      <Load></Load>
    </div>
  )
}

function AboutApp() {
  return (
    <div className="App">
      <Layout>
        <AppInfo></AppInfo>
      </Layout>
    </div>
  )
}

function AboutChat() {
  return (
    <div className="App">
      <Layout>
        <Chatscreen></Chatscreen>
      </Layout>
    </div>
  )
}


function Allusersunit() {
  return (
    <div className="App">
      <Layout>
        <Allusersunitplan></Allusersunitplan>
      </Layout>
    </div>
  )
}

function Singleusers() {
  return (
    <div className="App">
      <Layout>
        <SingleUserunitplan></SingleUserunitplan>
      </Layout>
    </div>
  )
}


function Allusersview(){
  return(
    <div className="App">
      <Layout>
        <Allusers></Allusers>
      </Layout>
    </div>
  )
}

function PaymentDetailsView() {
  return (
    <div className="App">
      <Layout>
        <PaymentDetails></PaymentDetails>
      </Layout>
    </div>
  )
}

function GetStartedView() {
  return (
    <div className="App">
    {/* <Layout> */}
      <GetStarted></GetStarted>
    {/* </Layout> */}
    </div>
  )
}

function SummaryView() {
  return (
    <div className="App">
    <Layout>
      <Summary></Summary>
    </Layout>
    </div>
  )
}
function UpdatesView() {
  return (
    <div className="App">
    <Layout>
      <Updates></Updates>
    </Layout>
    </div>
  )
}

function TimelineView() {
  return (
    <div className="App">
    <Layout>
      <Timeline></Timeline>
    </Layout>
    </div>
  )
}
function DocumentView() {
  return (
    <div className="App">
    <Layout>
      <DocumentsPage></DocumentsPage>
    </Layout>
    </div>
  )
}
function PollPageView() {
  return (
    <div className="App">
    <Layout>
      <PollPage></PollPage>
    </Layout>
    </div>
  )
}
function FormsView() {
  return (
    <div className="App">
    <Layout>
      <FormsPage></FormsPage>
    </Layout>
    </div>
  )
}
function WebsiteView() {
  return (
    <div className="App">
    <Layout>
      <WebsitePage></WebsitePage>
    </Layout>
    </div>
  )
}

const mapStateToProps = ({ auth }) => {
  const {
    authToken,
    userAccess
  } = auth

  return {
    authToken,
    userAccess
  }
}

const mapDispatchToProps = {
  setToken
}

export default connect(mapStateToProps, mapDispatchToProps)(App)